import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const { CancelToken } = axiosInstance;

export const loginEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/login`,
    method: 'post',
    data: data,
  });
};

export const getUserMenuEffect = () => {
  return axiosInstance.request({
    url: `${API.SECURITY}/getmenu`,
    method: 'get',
  });
};

export const getUserMenuItemsEffect = (NavigationID) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/getmenuitems`,
    method: 'get',
    params: {
      NavigationID,
    },
  });
};

export const getCompanyListEffect = () => {
  return axiosInstance.post(`${API.PRIMARY}/getcompanylist`, {});
};

export const forgotPasswordEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/ForgotPassword`,
    method: 'post',
    data,
  });
};

export const getUserTypesEffect = () => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetAllUserTypes`,
    method: 'get',
  });
};

export const userRegistrationEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/Signup`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  });
};

export const getUserProfileEffect = () => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetUserProfile`,
    method: 'get',
  });
};

export const updateUserProfileEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/UpdateProfile`,
    method: 'post',
    data,
  });
};

export const sendAuthenticationTokenEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/requesttwostepauthenticationtoken`,
    method: 'post',
    params,
  });
};

export const verifyAuthenticationTokenEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/logintwostepauthentication`,
    method: 'post',
    params,
  });
};

export const updateUserPasswordEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/changepassword`,
    method: 'post',
    data,
  });
};

let updateUserPreferenceEffectCancelToken = () => {};
export const updateUserPreferenceEffect = (data) => {
  updateUserPreferenceEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SECURITY}/SaveUserPreference`,
    method: 'post',
    data,
    cancelToken: new CancelToken(function executor(c) {
      updateUserPreferenceEffectCancelToken = c;
    }),
  });
};

export const getUserPreferenceEffect = () => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetUserPreference`,
    method: 'get',
  });
};

export const changeCompanyEffects = (params) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/changeCompany`,
    method: 'get',
    params,
  });
};

export const approveRejectShipmentEffects = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ActionNeededProcess`,
    method: 'post',
    data,
  });
};

export const getReportApplicationLinkEffect = (NavigationID) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetReportApplicationLink`,
    method: 'get',
    params: { NavigationID },
  });
};
